import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WelcomeComponent } from './welcome.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './notFound.component';
import { NoPermissionComponent } from './components/blocks/nopermission.component';
import { AuthGuard } from 'app/_guards/auth.guard';
import { GlobalsServiceResolver } from 'app/_services/globals.service';

const appRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent
        , resolve: {
            data: GlobalsServiceResolver
        }
    },
    {
        path: 'welcome',
        component: WelcomeComponent
        , canActivate: [AuthGuard]
        , resolve: {
            data: GlobalsServiceResolver
        }
    },
    {
        path: 'nopermission',
        component: NoPermissionComponent
    },
    {
        path: 'alta',
        loadChildren: './modules/alta/alta.module#AltaModule'
    },
    {
        path: 'administracio',
        loadChildren: './modules/administracio/administracio.module#AdministracioModule'
    },
    {
        path: 'canvi-semestre',
        loadChildren: './modules/canvi-semestre/canvi-semestre.module#CanviSemestreModule'
    },
    {
        path: 'gestio-materies',
        loadChildren: './modules/gestio-materies/gestio-materies.module#GestioMateriesModule'
    },
    {
        path: 'gestio-cicles',
        loadChildren: './modules/gestio-cicles/gestio-cicles.module#GestioUfModule',
    },
    {
        path: 'gestio-grups',
        loadChildren: './modules/gestio-grups/gestio-grups.module#GestioGrupsModule'
    },
    {
        path: 'adjudicacio-places',
        loadChildren: './modules/adjudicacio-places/adjudicacio-places.module#AdjudicacioPlacesModule'
    },
    {
        path: 'filtres-alumnes',
        loadChildren: './modules/filtres-alumnes/filtres-alumnes.module#FiltresAlumnesModule'
    },
    {
        path: 'filtres-fills',
        loadChildren: './modules/filtres-fills/filtres-fills.module#FiltresFillsModule'
    },
    {
        path: 'dades-personals',
        loadChildren: './modules/dades-personals/dades-personals.module#DadesPersonalsModule'
    },
    {
        path: 'documentacio',
        loadChildren: './modules/documentacio/documentacio.module#DocumentacioModule'
    },
    {
        path: 'itinerari',
        loadChildren: './modules/itinerari/itinerari.module#ItinerariModule'
    },
    {
        path: 'pagament',
        loadChildren: './modules/pagament/pagament.module#PagamentModule'
    },
    {
        path: 'certificats',
        loadChildren: './modules/certificats/certificats.module#CertificatsModule'
    },
    {
        path: 'rols',
        loadChildren: './modules/rols/rols.module#RolsModule'
    },
    {
        path: 'assessorament',
        loadChildren: './modules/assessorament/assessorament.module#AssessoramentModule'
    },
    {
        path: 'login-as',
        loadChildren: './modules/login-as/login-as.module#LoginAsModule'
    },
    {
        path: 'pafs',
        loadChildren: './modules/pafs-alumne/pafs-alumne.module#PafsAlumneModule'
    },
    {
        path: 'gestio-pafs',
        loadChildren: './modules/pafs-gestio/pafs-gestio.module#PafsGestioModule'
    },
    {
        path: 'gestio-tramits',
        loadChildren: './modules/gestio-tramits/gestio-tramits.module#GestioTramitsModule'
    },
    {
        path: 'gestio-tramits-alumne',
        loadChildren: './modules/gestio-tramits-alumne/gestio-tramits-alumne.module#GestioTramitsAlumneModule'
    },
    {
        path: 'qualificacio-proves',
        loadChildren: './modules/qualificacio-proves/qualificacio-proves.module#QualificacioProvesModule'
    },
    {
        path: 'mitjana-alumnes',
        loadChildren: './modules/mitjana-alumnes/mitjana-alumnes.module#MitjanaAlumnesModule'
    },
    {
        path: 'expedient',
        loadChildren: './modules/expedient/expedient.module#ExpedientModule'
    },
    {
        path: '',
        redirectTo: '/welcome',
        pathMatch: 'full'
        , resolve: {
            data: GlobalsServiceResolver
        }
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes
        )
    ],
    exports: [
        RouterModule
    ],
    providers: [ GlobalsServiceResolver ]
})
export class AppRoutingModule { }
